import cloneDeep from 'lodash/cloneDeep'

import {
  MessengerMessageTemplateDraft,
  MessengerMessageTemplateHeaderType,
} from 'shared/api/requests/messenger/schemas'

export function sanitizeMessageTemplateDraft(
  template: MessengerMessageTemplateDraft,
): MessengerMessageTemplateDraft {
  return {
    ...cloneDeep(template),
    body: trimIfExists(template.body),
    footer: trimIfExists(template.footer),
    header: sanitizeHeader(template.header),
    example: sanitizeExample(template.example),
    buttons: sanitizeButtons(template.buttons),
  }
}

function sanitizeHeader(
  header: MessengerMessageTemplateDraft['header'],
): MessengerMessageTemplateDraft['header'] | undefined {
  if (
    !Array.isArray(header) &&
    header?.type === MessengerMessageTemplateHeaderType.TEXT &&
    isEmptyOrUndefined(header.text)
  ) {
    return { ...header, text: undefined }
  }

  return header
}

function sanitizeExample(
  example: MessengerMessageTemplateDraft['example'],
): MessengerMessageTemplateDraft['example'] | undefined {
  if (example === undefined) {
    return undefined
  }

  const pruned = Object.fromEntries(
    Object.entries(example).filter(([, value]) => !isEmptyOrUndefined(value)),
  )

  return Object.keys(pruned).length > 0 ? pruned : undefined
}

function sanitizeButtons(
  buttons: MessengerMessageTemplateDraft['buttons'],
): MessengerMessageTemplateDraft['buttons'] | undefined {
  if (buttons === undefined) return undefined
  return buttons.map((button) => ({ ...button, text: trimIfExists(button.text) }))
}

const trimIfExists = (text: string | undefined) => (text && text.trim() !== '' ? text : undefined)
const isEmptyOrUndefined = (text: string | undefined) => text === undefined || text.trim() === ''
